<template>
  <div>
    <section class="page-banner" style="background-image: url(/static/img/bangi.png);">
    </section>
    <div class="box">
      <div class="tabinfo">
        <ul class="tab">
          <li @click="change(1)" :class="index==1&&'active'">快速资讯</li>
          <li @click="change(2)" :class="index == 2 && 'active'">通知公告</li>
          <li @click="change(3)" :class="index == 3 && 'active'">人才资讯</li>
        </ul>
        <ul class="listtab">
          <router-link tag="li" :to="`/news/info/${item.plateid}/${item._id}`" class="itemtab"
            v-for="item in tabsinfo" :key="item._id">
            <span class="tabname">{{ tabname }}</span>
            <h3 class="title">{{ item.title }}</h3>
            <p class="description">{{ item.description }}</p>
            <span class="time">{{ item.addtime | dateFormat }}</span>
            <span class="more">MORE</span>
          </router-link>
        </ul>
      </div>
      <router-link to="/inquery" tag="img" src="/static/img/dfs.png" width="1200" height="110"></router-link>
      <ul class="list">
        <router-link tag="li" :to="`/news/info/${item.plateid}/${item._id}`" class="item"
          v-for="item in articles" :key="item._id">
          <img class="img" :src="`https://www.zhcpw.org.cn/uploads/${item.picsrc}`" alt="">
          <h3 class="title">{{ item.title }}</h3>
          <p class="description">{{ item.description }}</p>
          <span class="time">{{ item.addtime | dateFormat }}</span>

        </router-link>
      </ul>
    </div>
  </div>

</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  name: "NewsViews",
  components: {
  },
  data() {
    return {
      plateId: this.$route.params.plateId || '',
      global,
      articles: [],
      index: 1,
      tabs: ["快速资讯", "通知公告", "人才资讯"],
      tabsinfo: [],
      plates: [],
      tabname: "快速资讯",
      routerName:""
    }
  },
  filters: {
    dateFormat: function (date) {
      return date ? date.substring(0, 10) : ""
    }
  },
  mounted() {
    this.$axios
      .get("/api/categorys?page=1&limit=30&firstView=1")
      .then((res) => {
        if (res.data) {
          this.plates = res.data.data;
          this.change(1);
        }
      });
    this.$axios.get(`/api/articles?plateid=${this.plateId}&page=1&limit=5&sort=-createdAt`).then(res => {
      if (res.data) {
        this.articles = res.data.data;
      }
    });
  },
  methods: {
    change(index) {
      this.index = index;
      let strplate = "";
      this.tabname = this.tabs[index - 1];
      for (var i = 0; i < this.plates.length; i++) {
        if (this.plates[i].name == this.tabs[index-1]) {
          strplate = this.plates[i]._id;
        }
        if (this.plateId == this.plates[i]._id) {
          this.routerName = this.plates[i].name;
        }
      }
      this.$axios.get(`/api/articles?plateid=${strplate}&page=1&limit=4&sort=-createdAt`).then(res => {
        if (res.data) {
          this.tabsinfo = res.data.data;
        }
      });
    }
  }
};
</script>
<style scoped>
.box{
  position: relative;
  width: 1200px;
  height: 1646px;
  margin: 0 auto;
}
.list{
  position: relative;
  width: 1200px;
  height: 895px;
}
.item{
  position: relative;
  cursor: pointer;
  width: 1200px;
  height: 222px;
  border-bottom: 1px solid #DCDCDC;
}
.item .img{
  position: absolute;
  left: -1px;
  top:38px;
  width: 257px;
  height: 152px;
  background: #333333;
  border-radius: 5px;
}
.item .title {
  position: absolute;
  left: 282px;
  top: 47px;
  width: 460px;
  height: 22px;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 22px;
  color: #333333;
  line-height: 22px;
  -webkit-background-clip: text;
    word-break: break-all;
    -webkit-box-orient: vertical;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
}
.item .description {
  position: absolute;
  left: 283px;
  top: 91px;
  width: 906px;
  height: 40px;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  line-height: 21px;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.item .time {
  position: absolute;
  left: 281px;
  top: 173px;
  height: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  line-height: 14px;
}
.tabinfo{
  position: relative;
  width: 1200px;
  height: 440px;
}
.tabinfo .listtab{
  position: relative;
  width: 1200px;
  height: 384px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.tabinfo .listtab .itemtab{
  cursor: pointer;
  position: relative;
  width: 284px;
  height: 304px;
  background: #FFFFFF;
  box-shadow: 0px 0px 16px 0px rgba(74, 74, 74, 0.16);
  border-radius: 5px;
}
.itemtab .title{
  position: absolute;
  top:54px;
  left:14px;
  width: 239px;
  height: 50px;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  line-height: 27px;
  -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.itemtab .description {
  position: absolute;
  top:136px;
  left:14px;
  width: 243px;
  height: 75px;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #797979;
  line-height: 27px;
  -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.itemtab .time {
position: absolute;
top:259px;
left:17px;
  height: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #797979;
  line-height: 14px;
}
.itemtab .tabname{
  position: absolute;
    top: 18px;
    left: 31px;
  width: 56px;
height: 14px;
font-family: PingFang SC;
font-weight: 400;
font-size: 14px;
color: #4462CF;
line-height: 14px;
}
.itemtab .tabname::before{
  position: absolute;
  top:3px;
  left: -15px;
  content: "";
  width: 8px;
    height: 8px;
    background: #E63232;
    border-radius: 50%;
}
.itemtab .more{
  
  position: absolute;
    top: 259px;
    left: 216px;
  width: 41px;
  height: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #4462CF;
  line-height: 14px;
}
.tabinfo .tab{
  cursor: pointer;
  margin-top: 27px;
  height: 50px;
  width: 1200px;
  border-bottom: 1px solid #DCDCDC;
}
.tab li{
  float: left;
  width: 72px;
  height: 50.5px;
  margin-right: 55px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #999999;
    line-height: 50px;
}
.tab li.active{
  border-bottom: 2px solid #4462CF;
  color: #4462CF;

}
</style>
